import React from 'react';
import {FormikErrors, FormikValues} from 'formik';
import LanguageBlock from '../sideForm/LanguageBlock';
import ElementConfiguration from '../../../models/form/ElementConfiguration';
import {LanguageId} from '../../../models/utils/Languages';
import SideFormInput from '../sideForm/SideFormInput';

type Props = {
  languages: LanguageId[]
  defaultLanguage: LanguageId
  configuration?: ElementConfiguration
  deleteTranslation: (langId: LanguageId) => void
  label: string
  errors: FormikErrors<FormikValues>
};
export default function SimpleQuestionTranslations({
  languages,
  configuration,
  defaultLanguage,
  deleteTranslation,
  label,
  errors,
}: Props) {
  return (
    <>
      {languages.map((languageId, index) =>
        <LanguageBlock langId={languageId} onDelete={deleteTranslation} deletable={languageId !== defaultLanguage}
          error={errors[languageId] !== undefined}
          opened={index === 0 || !configuration?.getLabel(languageId).length} key={languageId}>
          <SideFormInput id={languageId} name={languageId} label={label}/>
        </LanguageBlock>)
      }
    </>
  );
}
